import React, { useEffect, useRef, useState } from "react";
import ModalLoading from "../../components/ModalLoading";

export default function PolicyAgreementFragment({ setIsScrolled }) {
  //   state modal
  const [showModalLoading, setShowModalLoading] = useState(false);
  const policyRef = useRef(null);

  const handleScroll = () => {
    const policyElement = policyRef.current;
    if (policyElement) {
      const isBottom =
        policyElement.scrollHeight - policyElement.scrollTop ===
        policyElement.clientHeight;
      setIsScrolled(isBottom);
    }
  };

  useEffect(() => {
    const policyElement = policyRef.current;
    if (policyElement) {
      policyElement.addEventListener("scroll", handleScroll);
      return () => {
        policyElement.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  return (
    <>
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
      />
      <div className="mx-auto max-w-5xl px-1">
        <div
          ref={policyRef}
          className="h-80 overflow-y-scroll rounded-md border border-monochrome-50 bg-white px-3 py-2 shadow-md"
        >
          <div className="p-1.5 text-center text-sm">
            <span className="text-lg font-bold">
              Lisensi Dompet Kartini, Ketentuan Penggunaan, Dan Perjanjian
              Kerahasiaan
            </span>
            <br />
            <br />
            Terakhir Diperbarui 1 Agustus 2023 <br />
            V1.1.23
            <br />
            <br />
            <div className="text-justify">
              Terima kasih telah menggunakan Platform Dompet Kartini untuk
              mengakses semua fitur yang disediakan (“Fitur”). Untuk tujuan
              lisensi dan perjanjian ini:
              <br />
              <br />
              <ul class="ml-6 list-disc space-y-3">
                <li>
                  <strong>“Dompet Kartini”</strong> mengacu pada Dompet Kartini
                  dan pemilik merek dagang PT. Kartini Otomasi Indonesia dan
                  afiliasinya serta merek dagang yang dimiliki, yang dapat kami
                  rujuk dalam dokumen ini
                  <strong>“Dompet Kartini”</strong> sebagai{" "}
                  <strong>"Kami" atau Kita"</strong>;
                </li>
                <li>
                  <strong>"Lisensi"</strong> mengacu pada sistem Dompet Kartini
                  yang dapat diakses dalam bentuk Tampilan Mobile, Tampilan
                  Desktop, Aplikasi, atau bentuk lainnya yang mungkin muncul
                  sekarang atau di masa mendatang;
                </li>
                <li>
                  <strong>"Platform"</strong> mengacu pada dokumen ini dan
                  setiap perjanjian, ketentuan, kebijakan, dan pedoman Dompet
                  Kartini yang dirujuk (seperti, misalnya, Kebijakan Privasi
                  Dompet Kartini) termasuk yang dirujuk di sini;
                </li>
                <li>
                  <strong>"Pengguna"</strong> mengacu pada setiap pengguna yang
                  mengakses platform apakah itu akun administrator atau akun
                  anggota yang ditetapkan oleh administrator atau pemilik akun
                </li>
              </ul>
              <br />
              Lisensi ini membentuk kontrak hukum yang mengikat antara Dompet
              Kartini dan Anda mengenai akses Anda ke dan penggunaan salah satu
              fitur kami dan mengatur hubungan Anda dengan Dompet Kartini untuk
              tujuan tersebut. Dompet Kartini dapat memberikan ketentuan
              tambahan yang berlaku untuk fitur tertentu, dan ketentuan khusus
              tersebut juga dapat mengatur penggunaan Anda atas fitur tersebut.
              Jika ada pertentangan antara ketentuan khusus dan perjanjian ini,
              ketentuan yang lebih khusus akan memegang kendali.
              <br />
              <br />
              Dompet Kartini memberi Anda akses ke fitur-fitur tersebut sehingga
              Anda dapat memfasilitasi dan melakukan kegiatan dan program
              sebagai mitra kami <strong>(“Mitra Kartini”)</strong> dalam
              lingkungan bisnis Anda, termasuk menugaskan pengguna pilihan Anda{" "}
              <strong>(“Pengguna”)</strong>
              dan cabang <strong>(“Outlet”)</strong> di mana Lisensi ini
              berlaku.
              <br />
              <br />
              <strong>
                HARAP BACA LISENSI INI DENGAN TELITI. DENGAN MENYETUJUI UNTUK
                MENERIMA LISENSI INI, ANDA SETUJU UNTUK MEMATUHI LISENSI DAN
                MENGAKUI BAHWA ANDA TELAH MEMBACA DAN MEMAHAMI LISENSI.
              </strong>
              <br />
              <br />
              <strong>Bagian 1: Menggunakan Dompet Kartini</strong>
              <br />
              <br />
              <ul class="ml-6 list-none space-y-3">
                <li className="flex space-x-2">
                  <strong>a. </strong>
                  <span>
                    <strong>Lisensi Anda ke platform</strong>. Tunduk pada
                    jangka waktu Lisensi ini, Anda dengan ini diberikan lisensi
                    terbatas, non-eksklusif, tidak dapat dialihkan, tidak dapat
                    disublisensikan, dapat dicabut untuk menggunakan platform
                    sebagai alat untuk melakukan kegiatan dan program sebagai
                    Mitra Kartini dalam lingkungan bisnis Anda.
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>b. </strong>
                  <span>
                    <strong>
                      Kepatuhan terhadap Hukum dan Hak Pihak Ketiga
                    </strong>
                    . Saat menggunakan, mengakses, dan atau berinteraksi dengan
                    Platform, Anda akan mematuhi semua undang-undang, peraturan,
                    regulasi, dan hak pihak ketiga yang berlaku (termasuk, tanpa
                    batasan, undang-undang terkait impor atau ekspor data,
                    perangkat lunak, dan privasi){" "}
                    <strong>(“Hukum yang Berlaku”)</strong>. Anda tidak akan
                    menggunakan Platform untuk mendorong atau mempromosikan
                    aktivitas ilegal, penipuan keuangan, pelanggaran Lisensi
                    ini, pelanggaran Hukum yang Berlaku atau pelanggaran hak
                    pihak ketiga.
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>c. </strong>
                  <span>
                    <strong>Larangan</strong>. Saat menggunakan platform, Anda
                    tidak boleh, atau mengizinkan pihak ketiga mana pun, untuk
                    melakukan hal-hal berikut:
                    <br />
                    <br />
                    <ol className="ml-6 list-decimal space-y-3">
                      <li>
                        Mensublisensikan Platform untuk digunakan oleh pihak
                        ketiga selain Anda;
                      </li>
                      <li>
                        Memperkenalkan virus, worm, defect, trojan horse,
                        malware, atau item apa pun dengan sifat yang dapat
                        merusak Platform;
                      </li>
                      <li>
                        Mempromosikan atau memfasilitasi tindakan yang melanggar
                        hukum atau pesan komersial yang mengganggu atau iklan;
                      </li>
                      <li>
                        Merekayasa balik (backward engineering) atau berupaya
                        mengekstrak kode sumber Platform;
                      </li>
                      <li>
                        Melakukan segala upaya berindikasi kecurangan keuangan
                        yang mengakibatkan kerugian baik langsung maupun tidak
                        langsung terhadap Dompet Kartini dan kliennya{" "}
                        <strong>(“Klien”)</strong>.
                      </li>
                    </ol>
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>d. </strong>
                  <span>
                    <strong>
                      Batasan Penggunaan, Penangguhan, dan Pengakhiran
                    </strong>
                    . Atas kebijakan Dompet Kartini sendiri, Dompet Kartini
                    dapat menetapkan batasan, melakukan penangguhan dan
                    penghentian akses Mitra Kartini ke platform dengan
                    menunjukkan adanya pelanggaran terhadap Lisensi ini.
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>e. </strong>
                  <span>
                    <strong>Masukan</strong>. Anda dapat memberikan komentar dan
                    informasi Platform kepada Dompet Kartini{" "}
                    <strong>("Masukan")</strong>. Anda dengan ini memberikan hak
                    kepada Dompet Kartini untuk menggunakan masukan Anda atas
                    kebijakan Dompet Kartini tanpa kewajiban apapun kepada Anda,
                    untuk selama-lamanya.
                  </span>
                </li>
              </ul>
              <br />
              <strong>Bagian 2: Akun</strong>
              <br />
              <br />
              <ul class="ml-6 list-none space-y-3">
                <li className="flex space-x-2">
                  <strong>a. </strong>
                  <span>
                    <strong>Registrasi Awal</strong>. Dompet Kartini
                    mengharuskan Anda secara pribadi melakukan pendaftaran untuk
                    akun Anda
                    <strong>("Akun")</strong> di Platform secara pribadi. Tim
                    kami dapat meminta informasi awal untuk mendaftarkan akun
                    Anda termasuk namun tidak terbatas pada informasi pemilik
                    akun, informasi pengguna dan informasi outlet. Ini
                    dimaksudkan untuk membantu Anda mempercepat proses
                    pendaftaran, namun setelah pendaftaran awal Anda akan
                    diminta untuk memvalidasi semua informasi ini termasuk
                    memberikan informasi tambahan dan MENYETUJUI Lisensi ini.
                    Pada tahap ini Anda akan terdaftar sebagai Administrator
                    Akun <strong>(“Administrator”)</strong>.
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>b. </strong>
                  <span>
                    <strong>Informasi Pendaftaran</strong>. Setiap informasi
                    yang Anda berikan sebagai Administrator, apakah itu
                    informasi awal yang diberikan kepada tim kami yang akan Anda
                    divalidasi saat pendaftaran awal, atau informasi yang Anda
                    berikan secara langsung di dalam platform akan sepenuhnya
                    menjadi tanggung jawab Anda. Kartini tidak akan bertanggung
                    jawab atas ketidakakuratan informasi yang Anda berikan di
                    dalam platform.
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>c. </strong>
                  <span>
                    <strong>Pengguna dan Outlet</strong>. Dompet Kartini
                    menganggap setiap pengguna <strong>(“Member”)</strong> dan
                    outlet <strong>(“Outlet”)</strong> yang Anda tambahkan
                    selaku Administrator di bawah akun Anda, akan berada di
                    bawah preferensi dan tanggung jawab Anda sendiri. Dompet
                    Kartini sangat menyarankan agar Anda menambah member yang
                    dapat Anda pertanggungjawabkan dan menambah outlet yang
                    langsung berada di bawah kepemilikan Anda.{" "}
                    <strong>
                      SETIAP PERMASALAHAN YANG MUNGKIN TERJADI AKIBAT PENGGUNAAN
                      AKUN BAIK ADMINISTRATOR MAUPUN MEMBER YANG TIDAK
                      BERTANGGUNG JAWAB AKAN MENJADI TANGGUNG JAWAB PEMILIK AKUN
                      SEPENUHNYA.
                    </strong>
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>d. </strong>
                  <span>
                    <strong>Akun bank</strong>. Dompet Kartini menyediakan
                    sistem deposit dan dompet sebagai fitur pada platform. Untuk
                    mengaktifkan ini, Anda akan diminta untuk memberikan
                    informasi bank Anda{" "}
                    <strong>(“Rekening Bank Terdaftar”)</strong>. Anda akan
                    bertanggung jawab atas rincian rekening bank yang telah Anda
                    tambahkan. Detil rekening bank hanya dapat ditambah dan
                    diubah oleh Administrator.
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>e. </strong>
                  <span>
                    <strong>Konfirmasi Penebusan</strong>. Salah satu fitur inti
                    dari platform adalah untuk mengonfirmasi penebusan
                    <strong>("Penebusan")</strong> kupon digital. Fitur
                    penebusan disediakan di menu Penebusan platform. Anda akan
                    dimintai pertanggungjawaban atas penebusan yang dilakukan
                    melalui akun Anda. Anda berkewajiban untuk memberikan
                    informasi tambahan dan atau dokumen pendukung jika dalam hal
                    apa pun baik kami atau klien kami menduga adanya kesalahan
                    atau kesalahan informasi perihal penebusan.
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>f. </strong>
                  <span>
                    <strong>Keamanan Akun dan Kredensial</strong>. Anda akan
                    menjaga kerahasiaan kredensial Anda, dan Anda bertanggung
                    jawab atas keamanan akun dan kredensial Anda. Anda juga
                    bertanggung jawab atas semua aktivitas yang dilakukan
                    melalui akun Anda. Anda dapat memberi tahu tim kami jika
                    Anda menduga bahwa akun Anda telah disusupi.
                  </span>
                </li>
              </ul>
              <br />
              <strong>Bagian 3: Deposit dan E-Wallet</strong>
              <br />
              <br />
              <ul class="ml-6 list-none space-y-3">
                <li className="flex space-x-2">
                  <strong>a. </strong>
                  <span>
                    <strong>Alokasi Deposit</strong>. Dompet Kartini dapat
                    bertindak atas kebijakannya sendiri untuk mengalokasikan,
                    mengalokasikan kembali, menambah, atau mengurangi Alokasi
                    Deposit dari suatu Akun. Alokasi deposit TIDAK dianggap
                    sebagai bentuk pembayaran atau memiliki komitmen apa pun
                    kepada Mitra Kartini. Dompet Kartini dan Kliennya tidak akan
                    bertanggung jawab jika Anda terus melakukan aktivitas apapun
                    tanpa adanya deposit yang cukup. Anda dapat mengakses
                    alokasi deposit Anda melalui platform.
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>b. </strong>
                  <span>
                    <strong>Jumlah E-Wallet</strong>. Jumlah E-Wallet
                    menunjukkan jumlah yang dapat Anda tarik (“Penarikan”) ke
                    Rekening Bank Terdaftar Anda. Jumlah E-Wallet akan meningkat
                    seiring dengan konfirmasi Penebusan yang Anda lakukan
                    menggunakan Platform.
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>c. </strong>
                  <span>
                    <strong>Biaya Admin</strong>. Setiap Penarikan yang
                    dilakukan dapat dikenakan biaya admin yang dinyatakan pada
                    saat konfirmasi penarikan. Biaya admin akan dipotong dari
                    jumlah total penarikan dalam setiap penarikan.
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>d. </strong>
                  <span>
                    <strong>Akses Penarikan</strong>. Fungsi akses penarikan
                    hanya dapat dilakukan oleh akun administrator. Setiap
                    penarikan akan memerlukan verifikasi PIN yang akan dimintai
                    pada saat registrasi awal. Dompet Kartini dan kliennya TIDAK
                    BERTANGGUNG JAWAB atas penarikan tanpa izin yang dilakukan
                    oleh Mitra Kartini melalui Akun dan atau Penggunanya.
                  </span>
                </li>
              </ul>
              <br />
              <strong>Bagian 4: Kerahasiaan</strong>
              <br />
              <br />
              <ul class="ml-6 list-none space-y-3">
                <li className="flex space-x-2">
                  <strong>a. </strong>
                  <span>
                    <strong>Definisi Informasi Rahasia</strong>. “Informasi
                    Rahasia” berarti informasi yang diungkapkan oleh Anda atau
                    Dompet Kartini (“Pengungkap”) kepada pihak lain
                    (“Penerima”), baik secara lisan maupun tertulis, yang
                    dianggap rahasia atau orang yang wajar akan menganggapnya
                    rahasia mengingat sifat informasi atau keadaan pengungkapan.
                    Informasi Rahasia Anda mencakup informasi mengenai Layanan
                    Target dan Integrasi. Informasi Rahasia Dompet Kartini
                    mencakup informasi tentang API, Produk Kartini, dan semua
                    layanan terkait lainnya. Informasi Rahasia juga dapat
                    mencakup jenis informasi lain seperti, misalnya, rencana
                    bisnis dan pemasaran, teknologi dan informasi teknis, kode
                    perangkat lunak, rencana dan desain produk, serta proses
                    bisnis. Namun, Informasi Rahasia tidak termasuk informasi
                    yang (i) diketahui atau diketahui publik tanpa pelanggaran
                    hak Pengungkap, (ii) sebelumnya diketahui Penerima tanpa
                    pelanggaran hak Pengungkap atau kewajiban kerahasiaan, (iii)
                    diterima dari pihak ketiga tanpa melanggar hak Pengungkap
                    atau kewajiban kerahasiaan, atau (iv) dikembangkan sendiri
                    oleh Penerima.
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>b. </strong>
                  <span>
                    <strong>Pengungkapan yang Dipaksakan</strong>. Terlepas dari
                    segala hal yang bertentangan di sini, Penerima dapat
                    mengungkapkan Informasi Rahasia Pengungkap sejauh diwajibkan
                    oleh undang-undang, asalkan Penerima memberikan
                    pemberitahuan sebelumnya kepada Pengungkap tentang
                    pengungkapan wajib (sejauh diizinkan secara hukum) dan
                    bantuan yang wajar, di biaya Pengungkap, jika Pengungkap
                    ingin menggugat pengungkapan tersebut.
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>c. </strong>
                  <span>
                    <strong>Kewajiban Kerahasiaan</strong>. Penerima akan
                    melindungi Informasi Rahasia Pengungkap dengan menggunakan
                    tingkat kehati-hatian yang sama dengan yang digunakannya
                    untuk melindungi kerahasiaan informasi rahasianya sendiri
                    (namun tidak kurang dari kehati-hatian yang wajar). Sebagai
                    Penerima, Anda hanya akan menggunakan Informasi Rahasia
                    Dompet Kartini untuk penggunaan yang tepat dari Lisensi ini,
                    dan Dompet Kartini hanya akan menggunakan Informasi Rahasia
                    Anda untuk memberikan layanan kepada Anda berdasarkan
                    Lisensi ini (masing-masing, “Tujuan yang Tepat”). Penerima
                    harus mengungkapkan Informasi Rahasia Pengungkap hanya
                    kepada karyawan atau perwakilannya yang: (a) memerlukan
                    akses ke Informasi Rahasia untuk Tujuan yang Tepat, dan; (b)
                    yang telah menandatangani perjanjian kerahasiaan dengan
                    Penerima yang melindungi Informasi Rahasia Pengungkap
                    setidaknya seluas dan sebaik Lisensi ini. Kewajiban ini
                    tetap berlaku setelah pemutusan hubungan antara Anda dan
                    Dompet Kartini.
                  </span>
                </li>
              </ul>
              <br />
              <strong>Bagian 5: Jangka Waktu dan Pengakhiran</strong>
              <br />
              <br />
              <ul class="ml-6 list-none space-y-3">
                <li className="flex space-x-2">
                  <strong>a. </strong>
                  <span>
                    <strong>Penghentian</strong>. Kecuali jika Anda dan Dompet
                    Kartini telah menyetujui sebaliknya secara tertulis, Anda
                    atau Dompet Kartini dapat mengakhiri Lisensi ini kapan pun,
                    dengan alasan apa pun, dengan memberikan pemberitahuan
                    tertulis tiga puluh (30) hari sebelumnya kepada pihak
                    lainnya. Dompet Kartini berhak untuk menghentikan atau
                    menangguhkan akses Anda dan hak untuk menggunakan Platform
                    dengan segera jika Dompet Kartini mengetahui atau
                    mengantisipasi pelanggaran Lisensi ini oleh Anda, atau bahwa
                    tanpa penangguhan ada risiko kerusakan pada Dompet Kartini
                    atau pihak ketiga mana pun.
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>b. </strong>
                  <span>
                    <strong>Kewajiban Pasca Pengakhiran</strong>. Baik Anda
                    maupun Dompet Kartini tidak akan bertanggung jawab kepada
                    pihak lain atas penghentian Lisensi ini. Setelah
                    pengakhiran, Anda akan segera berhenti menggunakan platform
                    dan menghentikan semua penggunaan Merek Dagang Dompet
                    Kartini. Dompet Kartini dapat berkomunikasi secara mandiri
                    dengan Pengguna Akhir Layanan Target atau Integrasi untuk
                    memberikan pemberitahuan penghentian, atau untuk tujuan lain
                    yang sah. Untuk setiap jumlah E-Wallet yang tersisa setelah
                    penghentian, Dompet Kartini akan memverifikasi dan memproses
                    jumlah yang tersisa ke rekening bank terdaftar Anda.
                  </span>
                </li>
              </ul>
              <br />
              <strong>Bagian 6: Jaminan, Kewajiban, dan Ganti Rugi</strong>
              <br />
              <br />
              <ul class="ml-6 list-none space-y-3">
                <li className="flex space-x-2">
                  <strong>a. </strong>
                  <span>
                    <strong>Jaminan Bersama</strong>. Masing-masing dari kita
                    menyatakan dan menjamin bahwa kita telah secara sah
                    menandatangani Lisensi ini, dan bahwa dengan menandatangani
                    Lisensi ini masing-masing dari kita tidak melanggar
                    perjanjian atau kewajiban apa pun antara kita sendiri dan
                    pihak ketiga mana pun.
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>b. </strong>
                  <span>
                    <strong>Batasan Kewajiban</strong>. DOMPET KARTINI TIDAK
                    BERTANGGUNG JAWAB ATAS KERUGIAN KONSEKUENSIAL, LANGSUNG
                    MAUPUN TIDAK LANGSUNG, KHUSUS, HUKUMAN, TERMASUK KERUGIAN
                    KEHILANGAN KEUNTUNGAN, PENDAPATAN, ATAU DATA. PEMBATASAN DI
                    ATAS BERLAKU BAHKAN JIKA DOMPET KARTINI DIBERITAHU TENTANG
                    KEMUNGKINAN KERUGIAN TERSEBUT, DAN APA PUN JENIS KLAIM
                    TERMASUK, TANPA TERBATAS, PELANGGARAN KONTRAK, PELANGGARAN
                    JAMINAN, KELALAIAN, DAN KEWAJIBAN KERAS. Penafian,
                    pengecualian, dan batasan tanggung jawab yang ditetapkan
                    dalam Bagian ini merupakan dasar penting dari Lisensi ini.
                  </span>
                </li>
                <li className="flex space-x-2">
                  <strong>c. </strong>
                  <span>
                    <strong>Ganti Rugi</strong>. Anda akan membela, mengganti
                    rugi, dan membebaskan Dompet Kartini, dan anak perusahaan,
                    afiliasi, direktur, pejabat, karyawan, pemberi lisensi,
                    pelanggan, dan pemiliknya dari dan terhadap semua kewajiban,
                    kerusakan, kerugian, biaya (Termasuk biaya hukum), dan
                    pengeluaran berkaitan dengan klaim apa pun yang diajukan
                    oleh pihak ketiga sejauh yang timbul Platform oleh dari:
                    <br />
                    <br />
                    <ul className="ml-6 list-disc space-y-3">
                      <li>Penggunaan Platform oleh Anda;</li>
                      <li>Pelanggaran Anda terhadap Lisensi ini;</li>
                    </ul>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
